import { DynamicFormModule } from '@anecdotes/dynamic-form';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import {
  BaseModalComponent,
  ConfirmationModalWindowComponent,
  StatusWindowModalComponent,
  GlobalLoaderModalComponent,
  ModalTemplateHostComponent,
  AlertModalWindowComponent,
  ModalHostComponent,
  SidePanelModalComponent,
  CentralModalComponent,
  BaseSidePanelModalComponent,
  UploadFilesModalComponent,
} from './components';
import { ModalWindowService, GenericModalsService } from './services';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentSwitcherModule } from '@anecdotes/design-system/component-switcher';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ReactiveFormsModule } from '@angular/forms';
import { FormControlsModule } from '@anecdotes/design-system/form-controls';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  declarations: [
    ModalHostComponent,
    ConfirmationModalWindowComponent,
    StatusWindowModalComponent,
    BaseModalComponent,
    BaseSidePanelModalComponent,
    GlobalLoaderModalComponent,
    ModalTemplateHostComponent,
    AlertModalWindowComponent,
    SidePanelModalComponent,
    CentralModalComponent,
    UploadFilesModalComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    NgbTooltipModule,
    SvgIconsModule,
    ComponentSwitcherModule,
    RouterModule,
    NgbPopoverModule,
    DirectivesModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    ButtonsModule,
    UtilsModule,
    FormControlsModule,
    LoadersModule,
    OverlayModule,
    PortalModule,
    DynamicFormModule
  ],
  providers: [ModalWindowService, GenericModalsService],
  exports: [
    StatusWindowModalComponent,
    BaseModalComponent,
    BaseSidePanelModalComponent,
    ConfirmationModalWindowComponent,
    GlobalLoaderModalComponent,
  ],
})
export class ModalsModule {}
